"use client";
import { jsx as t, jsxs as u } from "react/jsx-runtime";
import * as r from "@radix-ui/react-select";
import { forwardRef as m } from "react";
import { ChevronDown as c, ChevronUp as p } from "../Icon/icons.gen.mjs";
import { cn as o } from "../../../utils/utils.mjs";
import { Text as d } from "../Text/Text.mjs";
import { getAccessibleFocusStyles as f } from "../../../utils/styles.mjs";
const y = ({ ...e }) => /* @__PURE__ */ t(r.Root, { "data-slot": "select", ...e }), N = ({ ...e }) => /* @__PURE__ */ t(r.Group, { "data-slot": "select-group", ...e }), C = ({ ...e }) => /* @__PURE__ */ t(r.Value, { "data-slot": "select-value", ...e }), h = m(
  ({ className: e, iconPrefix: a, iconSuffix: l, children: s, ...n }, i) => /* @__PURE__ */ u(
    r.Trigger,
    {
      "data-slot": "select-trigger",
      className: o(
        "group flex w-fit items-center justify-between gap-2 rounded-sm bg-transparent whitespace-nowrap disabled:cursor-not-allowed *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0",
        f(),
        e
      ),
      ref: i,
      ...n,
      children: [
        a && /* @__PURE__ */ t("div", { children: a }),
        s,
        l && /* @__PURE__ */ t("div", { children: l })
      ]
    }
  )
);
h.displayName = "SelectTrigger";
const k = ({ className: e, ...a }) => /* @__PURE__ */ t(
  c,
  {
    className: o(
      "size-3 fill-black transition-transform duration-200 group-data-[state=open]:rotate-180 dark:fill-white group-disabled:dark:fill-neutral-dark-600",
      e
    ),
    ...a
  }
), z = ({
  className: e,
  children: a,
  container: l,
  position: s = "popper",
  align: n = "start",
  ...i
}) => /* @__PURE__ */ t(r.Portal, { container: l, children: /* @__PURE__ */ t(
  r.Content,
  {
    "data-slot": "select-content",
    className: o(
      "relative z-50 max-h-(--radix-select-content-available-height) origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-xl data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      s === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: s,
    align: n,
    ...i,
    children: /* @__PURE__ */ t(
      r.Viewport,
      {
        className: o(
          s === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
        ),
        children: a
      }
    )
  }
) }), T = ({
  className: e,
  children: a,
  fontWeight: l,
  fontSize: s,
  fontFamily: n,
  ...i
}) => /* @__PURE__ */ t(
  r.Label,
  {
    "data-slot": "select-label",
    className: o("text-neutral-dark-600 dark:text-neutral-dark-1000 ", e),
    asChild: !0,
    ...i,
    children: /* @__PURE__ */ t(d, { asChild: !0, fontWeight: l, fontSize: s, fontFamily: n, children: a })
  }
), j = ({
  className: e,
  children: a,
  fontWeight: l,
  fontSize: s,
  fontFamily: n,
  ...i
}) => /* @__PURE__ */ t(r.ItemText, { asChild: !0, className: e, ...i, children: /* @__PURE__ */ t(d, { asChild: !0, fontWeight: l, fontSize: s, fontFamily: n, children: a }) }), I = ({ className: e, children: a, ...l }) => /* @__PURE__ */ t(
  r.Item,
  {
    "data-slot": "select-item",
    className: o(
      "relative flex w-full hover:cursor-pointer items-center gap-2 py-2 px-4 outline-hidden select-none data-disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
      e
    ),
    ...l,
    children: a
  }
), B = ({ className: e, ...a }) => /* @__PURE__ */ t(
  r.Separator,
  {
    "data-slot": "select-separator",
    className: o("pointer-events-none -mx-1 my-1 h-px bg-border", e),
    ...a
  }
), _ = ({ className: e, ...a }) => /* @__PURE__ */ t(
  r.ScrollUpButton,
  {
    "data-slot": "select-scroll-up-button",
    className: o("flex cursor-default items-center justify-center py-1", e),
    asChild: !0,
    ...a,
    children: /* @__PURE__ */ t(p, { className: "size-4" })
  }
), D = ({ className: e, ...a }) => /* @__PURE__ */ t(
  r.ScrollDownButton,
  {
    "data-slot": "select-scroll-down-button",
    className: o("flex cursor-default items-center justify-center py-1", e),
    asChild: !0,
    ...a,
    children: /* @__PURE__ */ t(c, { className: "size-3" })
  }
);
export {
  z as SelectContent,
  N as SelectGroup,
  k as SelectIcon,
  I as SelectItem,
  j as SelectItemText,
  T as SelectLabel,
  y as SelectRoot,
  D as SelectScrollDownButton,
  _ as SelectScrollUpButton,
  B as SelectSeparator,
  h as SelectTrigger,
  C as SelectValue
};
